const jsonUrl = '/user/documents/mpDrogerieFiltracniParametry.json?v=' + new Date().getMinutes();
let productCodes = [];

// Funkce pro načítání a uložení dat do sessionStorage
function loadDataAndStore(callback) {
    $.getJSON(jsonUrl, function(data) {
        sessionStorage.setItem('productData', JSON.stringify(data));
        console.log('Data loaded and stored in sessionStorage.');
        if (callback) callback();
    }).fail(function() {
        console.error('Failed to load JSON data.');
    });
}

// Funkce pro získání kódů produktů z variant
function getProductCodesFromVariants() {
    let codes = [];
    $('.choose-variant:not(.noDispaly)').each(function() {
        const code = $(this).text().trim();
        if (code && !isNaN(code)) {
            codes.push(code);
        }
    });
    return codes;
}

// Funkce pro zobrazení dat produktu
function displayProductData(productCode) {
    let productData = sessionStorage.getItem('productData');
    if (productData) {
        productData = JSON.parse(productData);
        const productInfo = productData.find(product => product.code === productCode);
        if (productInfo) {
            console.log('Product Info:', productInfo);
            const ksVKrabiciText = getKsVKrabiciText(productInfo.Krabice['Počet kusů v krabici']);
            const KsNaPalete = getKsNaPaleteText(productInfo.Paleta['Počet kusů na paletě']);
            let piecesPallete = '<div class="piecesPallete" data-code="' + productCode + '">'
                piecesPallete += '<h4>' + textKPalete + '</h4>'
                piecesPallete += '<div class="top">'
                    piecesPallete += '<div class="button" data-ks="'+productInfo.Krabice['Počet kusů v krabici']+'" data-price="'+Number(productInfo.Krabice['Počet kusů v krabici'] * parseFloat($('.p-final-price-wrapper .price-final-holder').text().trim().replace(/ /g, '').replace(',', '.')))+'">'
                        piecesPallete += '<strong>Krabice</strong>'
                        piecesPallete += '(obsahuje '+productInfo.Krabice['Počet kusů v krabici']+' '+KsNaPalete+')'
                    piecesPallete += '</div>'  
                    piecesPallete += '<div class="button" data-ks="'+productInfo.Paleta['Počet kusů na paletě']+'" data-price="'+Number(productInfo.Paleta['Počet kusů na paletě'] * parseFloat($('.p-final-price-wrapper .price-final-holder').text().trim().replace(/ /g, '').replace(',', '.')))+'">'
                        piecesPallete += '<strong>Paleta = '+productInfo.Paleta['Krabic na paletě']+' '+ksVKrabiciText+'</strong>'
                        piecesPallete += '(obsahuje '+formatNumberWithCommas(productInfo.Paleta['Počet kusů na paletě'])+' '+KsNaPalete+')'
                    piecesPallete += '</div>'   
                piecesPallete += '</div>'
                piecesPallete += '<div class="bottom">'
                piecesPallete += '</div>'
            piecesPallete += '</div>'
            piecesPallete += '<div class="variantInput">'
                piecesPallete +='<p>Tato varianta vloží do košíku <strong><span class="pieces"></span> ks</strong> produktu.</p>'
                piecesPallete +='<p>Cena za tuto variantu bude <span class="prices"></span>.</p>'
            piecesPallete += '</div>'
            if(getShoptetDataLayer('customer').registered){
                $('.p-info-wrapper').append(piecesPallete);
            }
            $('.piecesPallete .button').first().addClass('active').trigger('click');
            $('.variantInput strong span').html(formatNumberWithCommas($('.piecesPallete .button').first().attr('data-ks')));
            $('.variantInput span.prices').html(Number($('.piecesPallete .button').first().attr('data-price')).ShoptetFormatAsCurrency());
            $('.decrease-tooltip').attr('data-original-title', 'Minimální množství, které lze zakoupit, je '+formatNumberWithCommas($('.piecesPallete .button').first().attr('data-ks'))+' ks.')
        } else {
            console.error('Product not found.');
        }
    } else {
        console.error('No data in sessionStorage.');
        loadDataAndStore(() => displayProductData(productCode));
    }
}

$(document).ready(function() {
    if ($('.type-detail').length) {
        if ($('.variant-list').length) {
            $('#simple-variants select').on('change', function() {
                setTimeout(function(){
                    const selectedCode = $('.p-code .choose-variant:not(.no-display):not(.default-variant)').text().trim();
                    if (selectedCode && !isNaN(selectedCode)) {
                        displayProductData(selectedCode);
                        console.log(selectedCode)
                    }
                }, 150)
            });
        } else {
            const productCode = $('#product-detail-form meta[itemprop="sku"]').attr('content');
            productCodes.push(productCode);
            loadDataAndStore(() => displayProductData(productCode));
        }
    } else if ($('.id--9').length) {
        $('.removeable').each(function() {
            const productCode = $(this).attr('data-micro-sku');
            if (productCode) {
                productCodes.push(productCode);
            }
        });
        loadDataAndStore(processProductData);
    }
    else if ($('.id--16').length) {
        $('.cart-item[data-micro="cartItem"]').each(function() {
            const productCode = $(this).attr('data-micro-sku');
            if (productCode) {
                productCodes.push(productCode);
            }
        });
        loadDataAndStore(processProductData);
    }

    // Přidání event listeneru pro klikání na tlačítka v piecesPallete
    $(document).on('click', '.piecesPallete .button', function() {
        $('.piecesPallete .button').removeClass('active');
        $(this).addClass('active');
        $('.variantInput strong span').html(formatNumberWithCommas($(this).attr('data-ks')));
        $('.variantInput span.prices').html(Number($(this).attr('data-price')).ShoptetFormatAsCurrency());
        $('.add-to-cart .quantity input.amount').val($(this).attr('data-ks')).attr('value', $(this).attr('data-ks')).data('min', $(this).attr('data-ks')).attr('min', $(this).attr('data-ks'));
        $('.decrease-tooltip').attr('data-original-title', 'Minimální množství, které lze zakoupit, je '+formatNumberWithCommas($(this).first().attr('data-ks'))+' ks.')
    });
});

function getKsVKrabiciText(count) {
    if (count >= 1 && count <= 4) {
        return 'krabice';
    } else {
        return 'krabic';
    }
}

function getKsNaPaleteText(count) {
    if (count == 1) {
        return 'kus';
    }
    if (count >= 2 && count <= 4) {
        return 'kusy';
    } else {
        return 'kusů';
    }
}

function getPaleteText(count) {
    if (count == 1) {
        return 'paleta';
    }
    if (count >= 2 && count <= 4) {
        return 'palety';
    } else {
        return 'palet';
    }
}

function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function processProductData() {
    let productData = sessionStorage.getItem('productData');
    if (productData) {
        if ($('.id--9').length) {
            $('.checkout-box-wrapper').after('<div class="celkovyobjem">Celkový objem zboží je <span class="totalVolume"></span> m³.<br>Aktuální zaplnění je <span class="percentilVolume"></span></div>');
        } else if ($('.id--16').length) {
            // $('#shipping-billing-summary').after('<div class="celkovyobjem">Celkový objem zboží je <span class="totalVolume"></span> m³.<br>Aktuální zaplnění je <span class="percentilVolume"></span></div>');
        }
        productData = JSON.parse(productData);
        productCodes.forEach(productCode => {
            const productInfo = productData.find(product => product.code === productCode);
            if (productInfo) {
                const ksVKrabiciText = getKsVKrabiciText(productInfo.Krabice['Počet kusů v krabici']);
                const KsNaPalete = getKsNaPaleteText(productInfo.Paleta['Počet kusů na paletě']);
                if ($('.id--9').length) {
                    let totalVolume = 0;
                    $('.removeable').each(function() {
                        const sku = $(this).attr('data-micro-sku');
                        const amount = $(this).find('input.amount').val();
                        const product = productData.find(product => product.code === sku);
                        if (product) {
                            $(this).find('.quantity input.amount').attr('readonly','true');
                            $(this).find('input.amount').attr('min', product.Krabice['Počet kusů v krabici']).attr('data-min', product.Krabice['Počet kusů v krabici'])
                            const volume = (amount / parseFloat(product.Krabice['Počet kusů v krabici']))*parseFloat(product.Krabice['Objem krabice']);
                            totalVolume += volume;
                            $(this).attr('total-volume', volume);
                        }
                    });

                    const volumeRatio = totalVolume / objemPalety;
                    let wholePalettes = Math.floor(volumeRatio);
                    let partialPalette = ((volumeRatio % 1) * 100).toFixed(2);
                    let volumeOutput = '';
                    if (totalVolume < objemPalety) {
                        volumeOutput = partialPalette + '% z 1. palety.';
                    } else {
                        volumeOutput = wholePalettes + ' ' + getPaleteText(wholePalettes);
                        if (partialPalette > 0) {
                            volumeOutput += ' a ' + partialPalette + '% z další palety.';
                        }
                    }

                    $('.totalVolume').html(totalVolume.toFixed(2));
                    $('.percentilVolume').html(volumeOutput);
                } else if ($('.id--16').length) {
                    idDoprav.forEach(item => {
                        $('#order-shipping-methods>div#shipping-' + item.id).hide();
                    });
                    let totalVolume = 0;
                    $('.cart-item[data-micro="cartItem"]').each(function() {
                        const sku = $(this).attr('data-micro-sku');
                        const amount = $(this).find('.cart-item-amount').text().trim().replace('ks', '');
                        const product = productData.find(product => product.code === sku);
                        if (product) {
                            const volume = parseFloat(product.Krabice['Objem krabice']) * amount;
                            totalVolume += volume;
                            $(this).attr('total-volume', volume);
                        }
                    });

                    const volumeRatio = totalVolume / objemPalety;
                    let totalPalettes = Math.ceil(volumeRatio);
                    let matchingPocetPalet = idDoprav.find(item => item.pocetPalet >= totalPalettes);
                    if (matchingPocetPalet) {
                        $('#order-shipping-methods>div#shipping-' + matchingPocetPalet.id).show();
                    } else {
                        matchingPocetPalet = idDoprav[idDoprav.length - 1]; // Pokud není nalezeno, použije poslední položku
                        $('.next-step').addClass('button-disabled');
                        if (!$('.celkovyobjem').length) {
                            $('#shipping-billing-summary').after('<div class="celkovyobjem"><p>' + nenalezenaDoprava + '</p></div>');
                        }
                    }
                    if ($('#order-shipping-methods>div.radio-wrapper[data-id="shipping-4"].active').length) {
                        $('.next-step').removeClass('button-disabled');
                    }
                }
            } else {
                console.error('Product not found.');
            }
        });
    } else {
        console.error('No data in sessionStorage.');
        loadDataAndStore(processProductData);
    }
}

if (!sessionStorage.getItem('productData')) {
    if ($('.type-detail').length) {
        if ($('.variant-list').length) {
            $('#simple-variants select').on('change', function() {
                loadDataAndStore();
            });
        } else {
            loadDataAndStore();
        }
    }

    loadDataAndStore();
    if ($('.id--9').length) {
        document.addEventListener('ShoptetDOMCartContentLoaded', function() {
            loadDataAndStore();
        });
    }
} else {
    if ($('.type-detail').length) {
        if ($('.variant-list').length) {
            $('#simple-variants select').on('change', function() {
                processProductData();
            });
        } else {
            processProductData();
        }
    }

    if ($('.id--9').length) {
        document.addEventListener('ShoptetDOMCartContentLoaded', function() {
            processProductData();
        });
    }
}

$(document).on('click', '.piecesPallete .button', function() {
    $('.piecesPallete .button').removeClass('active');
    $(this).addClass('active');
    $('.variantInput strong span').html(formatNumberWithCommas($(this).attr('data-ks')));
    $('.variantInput span.prices').html(Number($(this).attr('data-price')).ShoptetFormatAsCurrency());
    $('.add-to-cart .quantity input.amount').val($(this).attr('data-ks')).attr('value', $(this).attr('data-ks')).data('min', $(this).attr('data-ks')).attr('min', $(this).attr('data-ks'));
});
